import { BudgetProposalT } from 'routes/BudgetModule/config/types';
import { useContext } from 'react';
import { getBudgetVentilatedQuery } from 'routes/BudgetModule/helpers/query';
import {
    useQuery,
    UseQueryOptions,
    UseQueryResult,
} from '@tanstack/react-query';
import { useGetBudgetVentilatedData } from '../../Resource/hooks/budgetProposal';
import { HttpError, RQAPICallWithData } from 'store/APIClient';
import { StatusSettingsContext } from 'routes/BudgetModule/components/BudgetWithProvider/StatusSettingsContext';

export const useGetBudgetVentilatedByOperation = ({
    budgetProposal,
    enabled = true,
}: {
    budgetProposal: BudgetProposalT;
    enabled: UseQueryOptions['enabled'];
}) => {
    const {
        data: budgetVentilatedData,
        isLoading: isBudgetVentilatedDataLoading,
        error,
        isError,
    } = useGetBudgetVentilatedData({
        budgetProposalId: budgetProposal.id,
        exercice: budgetProposal.exercice,
        isOperation: true,
        params: { enabled },
    });

    const statusesSettings = useContext(StatusSettingsContext);

    // INSCRIPTION QUERY //
    const budgetVentilatedQuery = getBudgetVentilatedQuery(
        budgetProposal,
        'operation',
        statusesSettings,
    );
    return {
        data: budgetVentilatedData,
        isLoading: isBudgetVentilatedDataLoading,
        query: budgetVentilatedQuery,
        isError,
        error,
    };
};

export const useGetCanCreateDraftOperation = ({
    budgetProposalId,
}: {
    budgetProposalId: number;
}): UseQueryResult<boolean, HttpError> => {
    return useQuery({
        queryKey: ['createDraftOperation', budgetProposalId],

        queryFn: async () => {
            const response = await RQAPICallWithData<{ canCreate: boolean }>({
                endpoint: `budget/draft_operation/${budgetProposalId}/can_create`,
                method: 'GET',
            });

            return response.content.data.canCreate;
        },
    });
};
